import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useFlightContext } from "hooks/flight/useFlightContext";
import useGetFlightCalendar from "hooks/flight/useGetFlightCalendar";
import { EMPTY_CALENDAR_FILTERS } from "helpers/flight-calendar-helpers";
import FlightCalendarGrid from "./FlightCalendarGrid";
import FlightCalendarFilters from "./FlightCalendarFilters";

const FlightCalendarArea = () => {
    const { flightSearchParams } = useFlightContext();
    const { t } = useTranslation();
    const { calendarLoading, calendarError, calendarData, getCalendarData } = useGetFlightCalendar();
    const [filters, setFilters] = useState(EMPTY_CALENDAR_FILTERS);

    useEffect(() => {
        getCalendarData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!flightSearchParams?.arrivalOption1 || !flightSearchParams?.departureOption1 || !flightSearchParams?.departureDate1) {
        return <Navigate to="/?tab=flight" />;
    }

    return (
        <div className="container py-5">
            {calendarLoading && (
                <div className="text-center py-5">{t("loading") || "..."}</div>
            )}
            {!calendarLoading && calendarError && (
                <div className="alert alert-danger">{calendarError}</div>
            )}
            {!calendarLoading && !calendarError && calendarData && (
                <div className="row g-4">
                    <div className="col-lg-3">
                        <FlightCalendarFilters
                            calendarData={calendarData}
                            filters={filters}
                            setFilters={setFilters}
                            isRoundTrip={flightSearchParams?.tripType === "rt"}
                        />
                    </div>
                    <div className="col-lg-9">
                        <FlightCalendarGrid calendarData={calendarData} flightSearchParams={flightSearchParams} filters={filters} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default FlightCalendarArea;
